import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IClientInfo } from 'src/app/model/client-info.interface';
import { RegexUtil } from '../../../../helpers/regex.helper';
import { CidaasService } from './../../../../service/cidaas.service';
import { SharedDataService } from './../../../../service/shared-data.service';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { isCidaasSystemUserId, loginMethodToQuery } from '../../../../model/domain/cidaas.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AppDialogComponent } from '../../app-dialog/app-dialog.component';
import { getProviderRedirectUrl, getUILocaleFromParam, LoginMethod } from 'src/app/model/domain/user.model';
import { ErrorResponse } from '../../../../model/api.model';
import { AppDialog } from '../../app-dialog/app-dialog.model';
import { DynamicFormComponent } from '../../../../dynamic-form/components/dynamic-form/dynamic-form.component';
import { KEY_DEFAULT_ERROR } from '../../../../model/error.model';

@Component({
  selector: 'app-classic-login-provider',
  templateUrl: './classic-login-provider.component.html',
  styleUrls: ['./classic-login-provider.component.scss'],
})
export class ClassicLoginProviderComponent implements OnInit, OnDestroy {

  protected readonly KEY_DEFAULT_ERROR = KEY_DEFAULT_ERROR;

  @Input() errorMessage = '';
  gloTypeRegister: string = '';
  shopSource: string = '';
  username = '';
  requestId = '';
  inviteId = '';
  linkId = '';
  clientInfo: any;
  Allow_Login_With: any[] = [];
  password_reseted = false;

  errorMsg = '';
  selectedLoginMethod = '';
  allowLoginMethod: any[] = [];
  selectedIndex: any = null;
  unsubscribe$ = new Subject<void>();
  isAppUser: boolean = false;

  @ViewChild('dynamicFormComponent', { static: true })
  formComponent!: DynamicFormComponent;

  isSubmitBtnClicked = false;
  dynamicFormOptions = {
    btnEnabled: false,
  };
  fields: any = [];
  usernameField: string = '';
  buttonOptions: any = {
    login: {
      color: 'accent',
      alignment: 'right',
      underline: 'none',
      for: 'cidaasSubmitBtn',
      formId: 'formId',
      text: 'LOGIN.CLASSICAL_LOGIN.BUTTON.TEXT',
      type: 'proceed',
      showImg: false,
    },
  };
  pageLoading = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _dataService: SharedDataService,
    private _cidaasSDK: CidaasService,
    private _regex: RegexUtil,
    private _translate: TranslateService,
    public dialog: MatDialog,
  ) {}

  ngOnDestroy(): void {
     this.unsubscribe$.next();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      let username = params.userIdHint ? params.userIdHint : '';
      this.requestId = params.requestId ? params.requestId : '';
      this.password_reseted = params.password_reseted ? params.password_reseted : false;
      this.usernameField = params.method ? params.method : '';
      this.inviteId = params.inviteId ? params.inviteId : '';
      username = params.login_hint ? params.login_hint : username;
      this.linkId = params.linkId ? params.linkId : '';
      this._updateUsername(username);
      this.errorMessage = params.error ? `error_codes.${this.errorMessage}` : '';
      this.shopSource = params.shop_source ? params.shop_source : '';
      this.gloTypeRegister = params.gloTypeRegister ? params.gloTypeRegister : '';
    });
    this._getClientInfo();

      this._dataService._getIsAppUser().subscribe(data => {
          if (data) {
              this.isAppUser = true;
          }
      });
  }

  _getClientInfo() {
    const values$ = combineLatest([this._dataService._getClientInfo(), this._dataService._getTranslationLoadStatus()]).pipe(
      map(([clientInfo, translationLoadStatus]) => {
        return { clientInfo, translationLoadStatus };
      })
    );

    values$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res) => {
      if (res.translationLoadStatus && Object.keys(res.clientInfo).length > 0) {
        this.clientInfo = res.clientInfo;
        this._getAllowLoginTypes(res.clientInfo);
      }
    });
  }

  // get  allow login types
  _getAllowLoginTypes = (data: Pick<IClientInfo, 'allow_login_with'>) => {
    this.allowLoginMethod = data.allow_login_with ? data.allow_login_with : [];
    if (this.allowLoginMethod && this.allowLoginMethod.length) {
      const username = this.username || this.formComponent.valueWithPrefix.username;
      const method = this._checkValueType(username);
      const index = this.allowLoginMethod.findIndex((item) => isCidaasSystemUserId(method) && method.toLowerCase() === item.toLowerCase() || method === item);
      if (index > -1) {
        this.getLoginMethod(this.allowLoginMethod[index], index);
      } else {
        this.getLoginMethod(this.allowLoginMethod[0], 0);
      }
    }
  }

  _updateUsername = (username) => {
    this.username = username ? username : '';
  }

  getTitleCaseWord(word: string) {
    return `LOGIN.CLASSICAL_LOGIN.ALLOW_LOGIN_WITH.${word}`;
    // if (!word) return word;
    // return word[0].toUpperCase() + word.substr(1).toLowerCase().replace(/[_]/g, '');
  }

  getLoginMethod(method: string, index: number) {
    // setTimeout(()=> {this._createField(method);}, 800)
    this.selectedLoginMethod = '';
    this.Allow_Login_With = [];
    this.errorMsg = '';
    this.selectedLoginMethod = method;
    this.Allow_Login_With.push(method);
    this.selectedIndex = index;
    // If not cidaas system field setting field as custom field
    this.usernameField = !isCidaasSystemUserId(method) &&  method || '';
    this._createField(method, this.username);
  }

  _createField(method: string, username: string) {
    this.fields = [];
    // const username = this._getUsername();
    switch (method) {
      case 'EMAIL':
        this.fields.push({
          dataType: 'EMAIL',
          parent_group_id: 'DEFAULT',
          is_group: false,
          fieldKey: 'username',
          fieldType: 'SYSTEM',
          order: 1,
          value: 'email' === this._checkValueType(username) && username || '',
          readOnly: false,
          required: true,
          autocomplete: 'email',
          fieldDefinition: {
            pattern: this._regex.email,
          },
          localeText: {
            locale: 'en-us',
            name: this._translate.instant(`LOGIN.CLASSICAL_LOGIN.ALLOW_LOGIN_WITH.${method}`),
            verificationRequired: 'Given Email is not verified.',
            required: this._translate.instant('REQUIRED_FIELD_DYNAMIC', {
              field: this._translate.instant(`LOGIN.CLASSICAL_LOGIN.ALLOW_LOGIN_WITH.${method}`),
            }),
            language: 'en',
            pattern: this._translate.instant('FORM.VALIDATION.EMAIL'),
          },
        });
        break;
      case 'MOBILE':
        this.fields.push({
          dataType: 'MOBILE',
          fieldKey: 'username',
          fieldType: 'SYSTEM',
          is_group: false,
          fieldDefinition: {
            invalidmobile: true,
          },
          localeText: {
            name: this._translate.instant(`LOGIN.CLASSICAL_LOGIN.ALLOW_LOGIN_WITH.${method}`),
            required: this._translate.instant('REQUIRED_FIELD_DYNAMIC', {
              field: this._translate.instant(`LOGIN.CLASSICAL_LOGIN.ALLOW_LOGIN_WITH.${method}`),
            }),
            invalidmobile: this._translate.instant('ENTER_VALID_MOBILE'),
          },
          value: 'mobile' === this._checkValueType(username) && username || '',
          order: 1,
          parent_group_id: 'DEFAULT',
          readOnly: false,
          required: true,
        });
        break;
      default:
        this.fields.push({
          dataType: 'TEXT',
          fieldKey: 'username',
          fieldType: method.toLowerCase() === 'user_name' && 'SYSTEM' || 'CUSTOM',
          is_group: false,
          localeText: {
            name: this._translate.instant(`LOGIN.CLASSICAL_LOGIN.ALLOW_LOGIN_WITH.${method}`),
            required: this._translate.instant('REQUIRED_FIELD_DYNAMIC', {
              field: this._translate.instant(`LOGIN.CLASSICAL_LOGIN.ALLOW_LOGIN_WITH.${method}`),
            }),
          },
          value: ('user_name' === this._checkValueType(username) || method === this._checkValueType(username)) && username || '',
          order: 1,
          parent_group_id: 'DEFAULT',
          readOnly: false,
          required: true,
        });
        break;
    }
  }

    _onClickRegisterGLO = (e): void => {
        if (!e){
            return;
        }
        this.router.navigate(['login'], {
            queryParams: {
                userIdHint: e?.username,
                requestId: this.requestId,
                type: loginMethodToQuery(this.selectedLoginMethod),
                gloTypeRegister: 'create'
            },
        });

        if (e instanceof KeyboardEvent) {
            // @ts-ignore
            document.querySelector('a').focus()
        }
    }

  _onSubmit = (e): void => {
    if (!e){
      return;
    }
    if (this.selectedLoginMethod !== '' || this.requestId) {
      this._updateUsername(e.username);
      this.pageLoading = true;
      this._cidaasSDK
        .getUserExistenceForRequestId$({
          requestId: this.requestId,
          username: e.username,
          loginMethod: this.selectedLoginMethod as LoginMethod
        })
        .subscribe(
          (result) => {
          this.pageLoading = false;

            if (result.action === 'redirect') {
              if (!result.providers || result.providers.length === 0) {
                return;
              }
              const locales = getUILocaleFromParam(this.activatedRoute.snapshot
                .queryParams);
              window.location.href = getProviderRedirectUrl(
                result.providers[0].redirectUri,
                {
                  ui_locales: locales,
                  login_hint: e.username
                }
              );
            }

            if (result.action === 'login') {
              this.pageLoading = false;
              this._dataService._setUser(e?.username);
              if (this.linkId) {
                this.router.navigate(['initiate'], {
                  relativeTo: this.activatedRoute,
                  queryParams: {
                    userIdHint: e?.username,
                    requestId: this.requestId,
                    type: loginMethodToQuery(this.selectedLoginMethod),
                    linkId: this.linkId,
                  },
                });
              } else {
                this.router.navigate(['initiate'], {
                  relativeTo: this.activatedRoute,
                  queryParams: {
                    userIdHint: e?.username,
                    requestId: this.requestId,
                    type: loginMethodToQuery(this.selectedLoginMethod)
                  },
                });
              }
            }

            if (result.action === 'register') {
              if (this._enableRegistration()) {
                this.router.navigate(['register'], {
                  queryParams: {
                    userIdHint: e?.username,
                    requestId: this.requestId,
                    type: loginMethodToQuery(this.selectedLoginMethod)
                  },
                });
              } else {
                this.errorMsg = 'NO_USER_FOUND';
              }
            }

            if (result.action === 'select') {
              this._dataService.setProviderData(result.providers);
              this.router.navigate(['provider_list'], {
                queryParams: {
                  login_hint: e?.username,
                  requestId: this.requestId,
                  type: loginMethodToQuery(this.selectedLoginMethod)
                },
              });
            }

            if (result.action === 'blocked') {
              this.dialog.open(AppDialogComponent, {
                data: {
                  title: 'LOGIN.SELECT_PROVIDERS.BLOCKED.TITLE',
                  description: 'LOGIN.SELECT_PROVIDERS.BLOCKED.MSG',
                  buttons: {
                    primaryButton: {
                      text: 'OK'
                    }
                  }
                } as AppDialog
              });
            }
          },
          (error) => {
            const err = error.rawResponse as ErrorResponse;
            if (err && err.error_code && err.error_code === 403) {
              this.router.navigate(['/error'], {
                queryParams: { error_hint: String(err.error).toLocaleUpperCase() },
                queryParamsHandling: 'merge',
              });
              return;
            }
          });

    } else {
      if (!this.requestId) {
        this.errorMsg = 'ERROR.MSG';
        return;
      }
      this.errorMsg = 'NO_USER_FOUND';
    }
  }



  _checkValueType = (value: string) => {
    const mobileRegx = this._regex.mobile;
    const emailRegx = this._regex.email;
    if (mobileRegx.test(value) && this.allowLoginMethod.includes('MOBILE')) {
      return 'mobile';
    }
    if (emailRegx.test(value) && this.allowLoginMethod.includes('EMAIL')) {
      return 'email';
    }

    if (value && this.usernameField && this.allowLoginMethod.includes(this.usernameField)) {
      return this.usernameField;
    }

    if (value && this.allowLoginMethod.includes('USER_NAME')) {
      return 'user_name';
    }

    return '';
  }

  _enableRegistration = (): boolean => {
    if (this.clientInfo?.registration_enabled) {
      return true;
    } else if (this.clientInfo?.invite_enabled && this.inviteId) {
      return true;
    } else {
      return false;
    }
  }
}
